import React from "react";

export const Spine = ({ size = 28, color = "#4ade80", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" className={className} fill="none">
    <defs>
      <linearGradient id="spine-grad" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#a7f3d0" />
        <stop offset="100%" stopColor={color} />
      </linearGradient>
    </defs>
    <path
      d="M32 6 C 24 14, 40 18, 32 26 C 24 32, 40 36, 32 44 C 24 50, 40 54, 32 60"
      stroke="url(#spine-grad)"
      strokeWidth={5}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <circle cx="32" cy="6" r="3.5" fill="url(#spine-grad)" />
  </svg>
);

export const LOGO_SRC =
  "https://customer-assets.emergentagent.com/job_posture-steps/artifacts/thxsgni3_posturestepsman.png";

export const Wordmark = ({ className = "", size = 160 }) => (
  <div
    className={`flex items-center ${className}`}
    data-testid="brand-wordmark"
  >
    <div
      className="relative rounded-full flex items-center justify-center shrink-0"
      style={{
        width: size,
        height: size,
        background:
          "radial-gradient(circle at 30% 25%, #a7f3d0 0%, #4ade80 45%, #16a34a 100%)",
        boxShadow:
          "0 0 0 2px rgba(255,255,255,0.08), 0 12px 40px -8px rgba(74,222,128,0.55), inset 0 -8px 24px rgba(0,0,0,0.25)",
      }}
    >
      <img
        src={LOGO_SRC}
        alt="Posture Steps — Walk Strong with Perfect Posture"
        style={{ width: size * 0.9, height: size * 0.9 }}
        className="block select-none object-contain"
        draggable={false}
      />
    </div>
  </div>
);
